import { jsxs as c, jsx as n } from "react/jsx-runtime";
import { ay as s, az as o, j as l, ax as i } from "./vendor-Dd6qj6gJ.js";
import { useContext as _ } from "react";
import { BaseIcon as r } from "./components/BaseIcon/index.js";
import './assets/CalendarHeader.css';const m = "_datePicker_m0wgj_1", u = "_horizontal_m0wgj_27", v = "_fullWidth_m0wgj_36", g = "_label_m0wgj_41", N = "_fieldControl_m0wgj_45", f = "_startIcon_m0wgj_94", h = "_dateInput_m0wgj_100", p = "_segment_m0wgj_114", j = "_trigger_m0wgj_141", w = "_popover_m0wgj_182", x = "_dialog_m0wgj_206", b = "_calendar_m0wgj_210", C = "_calendarHeader_m0wgj_225", H = "_calendarNavGroup_m0wgj_231", $ = "_calendarNavButton_m0wgj_237", k = "_calendarNavChevronStacked_m0wgj_269", z = "_calendarHeading_m0wgj_273", P = "_calendarGrid_m0wgj_281", B = "_calendarHeaderCell_m0wgj_285", D = "_calendarCell_m0wgj_294", e = {
  datePicker: m,
  horizontal: u,
  fullWidth: v,
  label: g,
  fieldControl: N,
  startIcon: f,
  dateInput: h,
  segment: p,
  trigger: j,
  popover: w,
  dialog: x,
  calendar: b,
  calendarHeader: C,
  calendarNavGroup: H,
  calendarNavButton: $,
  calendarNavChevronStacked: k,
  calendarHeading: z,
  calendarGrid: P,
  calendarHeaderCell: B,
  calendarCell: D
};
function V() {
  const a = _(s), t = !a || !!a.minValue && a.focusedDate.year <= o(a.minValue, a.focusedDate.calendar).year, d = !a || !!a.maxValue && a.focusedDate.year >= o(a.maxValue, a.focusedDate.calendar).year;
  return /* @__PURE__ */ c("header", { className: e.calendarHeader, children: [
    /* @__PURE__ */ c("div", { className: e.calendarNavGroup, children: [
      /* @__PURE__ */ c(
        l,
        {
          slot: null,
          className: e.calendarNavButton,
          "aria-label": "Previous year",
          isDisabled: t,
          onPress: () => a?.focusPreviousSection(!0),
          children: [
            /* @__PURE__ */ n(r, { icon: "chevron-back", size: "sm" }),
            /* @__PURE__ */ n(r, { icon: "chevron-back", size: "sm", className: e.calendarNavChevronStacked })
          ]
        }
      ),
      /* @__PURE__ */ n(l, { className: e.calendarNavButton, slot: "previous", "aria-label": "Previous month", children: /* @__PURE__ */ n(r, { icon: "chevron-back", size: "sm" }) })
    ] }),
    /* @__PURE__ */ n(i, { className: e.calendarHeading }),
    /* @__PURE__ */ c("div", { className: e.calendarNavGroup, children: [
      /* @__PURE__ */ n(l, { className: e.calendarNavButton, slot: "next", "aria-label": "Next month", children: /* @__PURE__ */ n(r, { icon: "chevron-next", size: "sm" }) }),
      /* @__PURE__ */ c(
        l,
        {
          slot: null,
          className: e.calendarNavButton,
          "aria-label": "Next year",
          isDisabled: d,
          onPress: () => a?.focusNextSection(!0),
          children: [
            /* @__PURE__ */ n(r, { icon: "chevron-next", size: "sm" }),
            /* @__PURE__ */ n(r, { icon: "chevron-next", size: "sm", className: e.calendarNavChevronStacked })
          ]
        }
      )
    ] })
  ] });
}
export {
  V as C,
  e as c
};
